import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState
} from 'react'
import Toast from 'react-bootstrap/Toast'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleInfo } from '@fortawesome/pro-regular-svg-icons/faCircleInfo'
import './style.css'

const BasicToast = forwardRef(({ title, body }, ref) => {
  const [show, setShow] = useState(false)
  const wrapperRef = useRef(null)

  useImperativeHandle(ref, () => {
    return {
      setShow
    }
  })

  useEffect(() => {
    const handleScroll = () => {
      setShow(false)
    }
    const handleClickOutside = (event) => {
      let hideOverlay = true
      ;[wrapperRef].forEach((ref) => {
        if (ref.current && ref.current.contains(event.target)) {
          hideOverlay = false
        }
      })
      if (hideOverlay) {
        setShow(false)
      }
    }
    window.addEventListener('scroll', handleScroll)
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      window.removeEventListener('scroll', handleScroll)
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  return (
    <div
      ref={wrapperRef}
      className="position-fixed top-0 start-50 top-50 translate-middle"
      style={{ zIndex: 9999, marginTop: '40px' }}
    >
      <Toast show={show} onClose={() => setShow(false)}>
        <Toast.Header
          style={{ background: 'rgba(181, 90, 48, 0.6)', color: 'white' }}
        >
          <FontAwesomeIcon
            icon={faCircleInfo}
            style={{ marginRight: '10px', paddingTop: '2px' }}
          />
          <strong className="me-auto">{title}</strong>
        </Toast.Header>
        <Toast.Body>{body}</Toast.Body>
      </Toast>
    </div>
  )
})

BasicToast.displayName = 'BasicToast'

export default BasicToast
